import { useQuery } from "@apollo/client";
import { Box, List, ListItem } from "@mui/material";
import Image from "next/image";
import { useContext, useEffect, useState } from "react";
import { GET_PRODUCTS_SEARCHES } from "../../graphql/search/queries";
import useTranslation from "../../hooks/useTranslation";
import { CompareListContext } from "../../Providers/CompareListContext";
import cssVars from "../../styles/vars.module.scss"
import { useTheme } from "@mui/material";

const CompareSearchRes = ({ search, setSearch }) => {

    const [skip, setSkip] = useState(true)
    const [searchRes, setSearchRes] = useState([])
    const { data: productsSearches } = useQuery(GET_PRODUCTS_SEARCHES, { variables: { search }, skip })

    const { compareList, addProductToCompareList, isCompared } = useContext(CompareListContext)

    useEffect(() => {
        setSkip(false)
    }, [search])

    useEffect(() => {
        if (productsSearches) {
            setSearchRes(productsSearches.getProductsSearches.items.filter(item => !isCompared(item.id)))
            setSkip(true)
        }
    }, [productsSearches])

    const add = (id) => {
        addProductToCompareList({
            variables: {
                uid: compareList.uid,
                productID: id,
            },
            onCompleted: () => { setSearch("") }
        });
    }
    const theme = useTheme()

    return (
        <Box>
            {
                searchRes.length > 0
                    ?
                    <List sx={{ fontSize: "14px", textTransform: "capitalize" }}>
                        {
                            searchRes.map(product =>
                                <ListItem disablePadding display="flex" alignItems="center" key={product.sku} onClick={() => { add(product.id) }}
                                    sx={{ py: 2, px: 1, cursor: "pointer", ":hover": { bgcolor: cssVars.extraLightGray } }}
                                >
                                    <Image width={54} height={54} style={{ objectFit: "contain", objectPosition: "center" }} alt={product.name} src={product.small_image.url} />
                                    <Box className="details" fontSize={13} ml={2}>
                                        <Box sx={{ color: theme.palette.primary.main, fontWeight: 500 }}>{product.brand_label}</Box>
                                        <Box sx={{ my: 0.5 }} dangerouslySetInnerHTML={{ __html: product.name }} />
                                    </Box>
                                </ListItem>
                            )
                        }
                    </List>
                    :
                    null
            }
        </Box>
    );
}

export default CompareSearchRes;